import React, { useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import AdminTable from "../Helpers/AdminTable"
import { useState, useMemo } from "react"
import { getCertificates } from "src/store/Slices/Administrator/CertificatesSlice"
import TableTitle from "../Helpers/TableTitle"
import dayjs from "dayjs"

const Certificates = () => {
  const dispatch = useDispatch()

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [seeCode, setSeeCode] = useState(false)
  const [filters, setFilters] = useState({})

  const certificatesListLoading = useSelector(
    (state) => state.CertificatesSlice.certificatesListLoading,
  )
  const certificatesList = useSelector(
    (state) => state.CertificatesSlice.certificatesList,
  )

  const myInfo = useSelector(
    (state) => state.AuthSlice?.myInfo, 
  )

  const checkViewCertificateCodePermission = () => {
    try {
      const adminSection = myInfo?.data?.value?.formViews?.find(
        view => view.mnemo === "administrator"
      )
      
      if (!adminSection) return false
      
      const certificatesSection = adminSection.children?.find(
        child => child.mnemo === "certificateTable"
      )
      
      if (!certificatesSection) return false
      
      const hasPermission = certificatesSection.children?.some(
        child => child.mnemo === "viewCertificateCode"
      )
      
      return hasPermission || false
    } catch (error) {
      console.error("Error checking permission:", error)
      return false
    }
  }

 const searchItemsMap = (keys, values) => {
  const formattedItems = {}
  if (keys && values) {
    keys.forEach((key, index) => {
      if (values[index] !== undefined && values[index] !== null && values[index][0] !== undefined && values[index][0] !== null) {
        const value = values[index][0]
        
        if (key === "sentAt" && Array.isArray(value)) {
          formattedItems["sentAt.From"] = dayjs(value[0]).format("YYYY-MM-DD")
          formattedItems["sentAt.To"] = dayjs(value[1]).format("YYYY-MM-DD")
        }
        else if (key === "isUsed") {
          formattedItems["isUsed"] = value
        }
        else if (key === "usedBy") {
          formattedItems["usedBy"] = value
        }
        else if (!Array.isArray(value)) {
          formattedItems[key] = value
        }
      }
    })
  }
  return formattedItems
}

  const loadCertificates = (filterParams = {}) => {
    dispatch(
      getCertificates({
        value: {
          count: pageSize,
          offset: pageSize * (page - 1),
          ...filterParams,
        },
        seeCode: seeCode 
      })
    )
  }

 const handleTableChange = (pagination, tableFilters, sorter) => {
  const payload = searchItemsMap(Object.keys(tableFilters), Object.values(tableFilters))
  
  setFilters(payload)
  
  dispatch(
    getCertificates({
      value: {
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order ? sorter.order === "descend" : undefined,
        ...payload,
      },
      seeCode: seeCode
    })
  )
  
  setPage(pagination.current)
  setPageSize(pagination.pageSize)
}

  useEffect(() => {
    if (myInfo) {
      const hasViewCodePermission = checkViewCertificateCodePermission()
      setSeeCode(hasViewCodePermission)
      loadCertificates()
    }
  }, [myInfo])

  useEffect(() => {
    if (myInfo) {
      loadCertificates(filters)
    }
  }, [page, pageSize])

  const formatedCertificatesRows = useMemo(() => {
    if (!certificatesList?.data?.value?.rows) return []
    
    return certificatesList.data.value.rows.map((element) => ({
      ...element,
      certificateCode: element.code,
      activeUntil: element.activeUntil
        ? dayjs(element.activeUntil).format("DD.MM.YYYY")
        : "",
    }))
  }, [certificatesList])

  return (
    <>
      {window.innerWidth >= 768 ? (
        <AdminTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={certificatesListLoading}
          columns={certificatesList}
          rows={formatedCertificatesRows}
          total={certificatesList?.data?.value?.totalCount}
        />
      ) : (
        <AntdMobileTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          elementsList={certificatesList}
          elementsListLoading={certificatesListLoading}
          handlePaginationChange={handlePaginationChange}
        />
      )}
    </>
  )
}

export default Certificates